import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=1b752b9e&scoped=true&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "@/components/Form/Import/Import.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Import.vue?vue&type=style&index=1&id=1b752b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b752b9e",
  null
  
)

export default component.exports